import { render, staticRenderFns } from "./BirthdayRegistries.vue?vue&type=template&id=78929338&"
import script from "./BirthdayRegistries.vue?vue&type=script&lang=js&"
export * from "./BirthdayRegistries.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayRegistries.vue?vue&type=style&index=0&id=78929338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports